/*
 * @Author: your name
 * @Date: 2021-03-26 11:18:29
 * @LastEditTime: 2024-11-13 11:03:55
 * @LastEditors: bpang bpang@vocust.com
 * @Description: In User Settings Edit
 * @FilePath: /report/packages/report/src/hotelcem/apis/comment/commentAnalysis.js
 */

import { fecthGet, fecthPost, fecthDelete } from '@/hotelcem/apis/request'
import apiUtils from '@/hotelcem/apis/api-utils.js'

export default {
  // 点评分析
  commentAnalysis(params) {
    return fecthPost('/cem/hotel/comment/analysis', params)
  },
  // 点评分析详情
  commentAnalysisDetail(params) {
    return fecthPost('/cem/hotel/comment/analysis/detail', params)
  },
  // 点评分析趋势
  commentAnalysisTrend(params) {
    return fecthPost('/cem/hotel/comment/score/trend', params)
  },
  // 点评分总量趋势
  commentPointTotalTrend(params) {
    return fecthPost('/cem/hotel/data-source/comment/statistics/trend', params)
  },
  // 差评相关指标
  badCommentIndex(params) {
    return fecthPost('/cem/comment/topics', params)
  },
  // 最新点评文本
  laestCommentTxt(params) {
    return fecthPost('/cem/dataCube2/detailQuery', params)
  },
  // 社交媒体配置查询
  paramsQuery(params) {
    return fecthGet('/cem/hotel/data-source/reptile/config', params)
  },
  // 点评分趋势
  commentPointTrend(params) {
    return fecthPost('/cem/hotel/point/score/trend', params)
  },

  // 各渠道当前得分
  currentChannelScore(params) {
    return fecthGet('/cem/comment/current-score', params)
  },
  // 当前提升点评分任务进度信息
  channelTargetProcessInfo(params) {
    return fecthGet('/cem/comment/score/task/process-info', params)
  },
  // 设置点评分慕白哦
  setTarget(params) {
    return fecthPost('/cem/comment/score/task/add', params)
  },
  //获取上一次设置详情，包含目标得分
  getCurrentAuthInfo(params) {
    return fecthGet('/cem/comment/score/task/detail', params)
  },
  //获取外网趋势得分等
  getNetScore(params) {
    return fecthPost('/cem/hotel/channel/comment/score/trend', params)
  },
  // 点评回复率
  commentReplyRate(params) {
    return fecthPost('/cem/comment/reply/rate', params)
  },
  // 未回复差评数
  badCommentUnReplyNums(params) {
    return fecthPost('/cem/comment/unreply/bad/count', params)
  },
  // 未回复点评数
  commentPointUnReplyNums(params) {
    return fecthPost('/cem/comment/unreply/count', params)
  },
  // 华客点评分数
  vocustCommentScore(params) {
    if (params.channelIds instanceof Array) {
      params.channelIds = params.channelIds.join()
    }
    return fecthGet('/cem/comment/vocust/score', params)
  },
  // 渠道平均分
  channelAvgScore(params) {
    if (params.channelIds instanceof Array) {
      params.channelIds = params.channelIds.join()
    }
    return fecthGet('/cem/comment/avg/score', params)
  },
  channelPeriodScore(params) {
    if (params.channelIds instanceof Array) {
      params.channelIds = params.channelIds.join()
    }
    return fecthGet('/cem/comment/period/avg/score', params)
  },
  // 差评率趋势
  badCommentTrend(params) {
    return fecthPost('/cem/comment/bad/rate/trend', params)
  },
  // 差评回复率趋势
  badCommentReplyTrend(params) {
    return fecthPost('/cem/comment/bad/reply/rate/trend', params)
  },
  // 好评率趋势
  goodCommentTrend(params) {
    return fecthPost('/cem/comment/good/rate/trend', params)
  },
  // 触发点评预警
  getAlertCount(params) {
    return fecthPost('/hotel-info/comment/alert/count', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 查看率趋势
  getWarningViewsRate(params) {
    return fecthPost('/hotel-info/comment/alert/read-rate', params, { baseURL: '/api/v1/cem-4x' })
  },
  // 预警平均响应时长
  getWarningResponseTime(params) {
    return fecthPost('/hotel-info/comment/alert/response/avg-time', params, { baseURL: '/api/v1/cem-4x' })
  },
  //到达目标分需要的点评条数
  toTargetNeed(params) {
    return fecthGet('/cem/comment/score/task/need-count', params)
  },
  /****介入到4x接口 start ***/
  // 酒店列表
  searchHotelList() {
    return fecthGet('/cem/hotel/list')
  },
  // 文本分析
  searchAnalysiaContent(params) {
    params.queryTotal = false
    let url = params.isGroup ? '/cem/multi/detailQuery' : '/cem/dataCube2/detailQuery'
    return fecthPost(url, params, {
      cancelToken: apiUtils.createUrlToken(url),
    })
  },
  // 文本分析总数
  searchAnalysiaContentCount(params) {
    params.queryTotal = true
    let url = params.isGroup ? '/cem/multi/detailQueryCount' : '/cem/dataCube2/detailQueryCount'
    return fecthPost(url, params, {
      cancelToken: apiUtils.createUrlToken(url),
    })
  },
  // 指标树
  listCommentLabelsTree(params) {
    let url = params.isGroup ? 'cem/multi/detailTreeQuery ' : '/cem/dataCube2/detailTreeQuery'
    return fecthPost(url, params, {
      cancelToken: apiUtils.createUrlToken('/cem/dataCube/detailTreeQuery'),
    })
  },
  // 获取用户类型
  // getCommentType(params) {
  //   return fecthPost('/cem/dataCube/getCommentType', params)
  // },
  /****介入到4x接口 end ***/

  // 获取竞对酒店列表及点评数量
  getCompetitorCommentCount(params) {
    return fecthPost('/cem/dataCube/detailAmount', params)
  },

  // 最新数据同步时间查询
  getLeastDataTime(params) {
    return fecthPost('/cem/dataCube/update-time', params)
  },

  // 文本分析
  groupDetailQuery(params) {
    params.queryTotal = false
    return fecthPost('/cem/dataCube2/group/detailQuery', params)
  },
  groupDetailQueryCount(params) {
    params.queryTotal = true
    return fecthPost('/cem/dataCube2/group/detailQueryCount', params)
  },
  // 指标树
  groupDetailTreeQuery(params) {
    return fecthPost('/cem/dataCube2/group/detailTreeQuery', params)
  },

  // **** 华客分单独页面 *****//

  // 明日计划
  getTomorrowScore(params) {
    return fecthGet('/cem/vocust-score-task/predict-score', params)
  },
  //酒店得分趋势
  getHotelScoreTrend(params) {
    return fecthPost('/cem/vocust-score-task/score/trend', params)
  },
  //每日任务，和计划完成情况是通用的
  getTaskProcess(params) {
    return fecthPost('/cem/vocust-score-task/process-info', params)
  },
  // 大任务详情
  getBigTaskDetail(params) {
    return fecthGet('/cem/vocust-score-task/detail', params)
  },
  // 观点贡献度
  getViewAnalysis(params) {
    return fecthPost('/cem/hotel/label/contribution', params)
  },
  // 往期计划
  getHistoryTasks(params) {
    return fecthPost('/cem/vocust-score-task/list', params)
  },

  // 设置华客分任务
  setNewTask(params) {
    return fecthPost('/cem/vocust-score-task/add', params)
  },
  // 获取竞圈平均分   /cem/hotel/compete-analysis/avg-score
  getScoreOthers(params) {
    return fecthPost('/cem/hotel/compete-analysis/avg-score', params)
  },
  // 实时算任务达成条件
  reachPlanCount(params) {
    return fecthPost('/cem/vocust-score-task/reach-plan', params)
  },

  // 获取当前开启的模式，是nps进阶还是普通
  getMode(params) {
    return fecthGet('/cem/vocust-score-task/tenant-config/detail', params)
  },
  //查询是否开启了竞对
  getJDStatus(params) {
    return fecthGet('/cem/hotel/competitor/status', params)
  },
  // 查询竞对得分列表
  getJDScore(params) {
    return fecthPost('/cem/vocust-score-task/competitor/score', params)
  },

  // 查询竞对得分列表
  getTrendNPS(params) {
    return fecthPost('/cem/vocust-score-task/score/detail', params)
  },
  getTrendNPSCSI(params) {
    return fecthPost('/cem/hotel-rank/csi/score/daily', params)
  },

  // 平均回复数-趋势图/匹配度
  fetchAvgReplyNumber(params) {
    return fecthPost('/cem/comment/reply/word/number', params)
  },
  // 逾期回复数-趋势图
  fetchLateReplyNumber(params) {
    return fecthPost('/cem/comment/reply/expire/number', params)
  },
  // 是否逾期接口
  fetchIsLate(params) {
    return fecthPost('/cem/comment/examine-reply-channel/expiry/detail', params)
  },
  // 智能回复联想
  fetchSmartReplyTemplate(params) {
    return fecthPost('cem/comment/reply/template', params)
  },
  // 携程4小项分
  fetchExtralScore(params) {
    return fecthGet('cem/comment/commentDetailScore', params)
  },
  // 点评分析导出详情数据
  fetchCommentAnalysisExport(params) {
    return fecthPost('/cem/hotel/comment/analysis/export', params)
  },
  fetchIndustryType(params) {
    return fecthPost('/tenant/manager/industryInfo', params)
  },
  // 点评详情
  fetchCommentDetail(params) {
    return fecthPost('/cem/comment/detail', params)
  },
  // 点评情感趋势
  fetchCommentSentiment(params) {
    return fecthPost('/cem/comment/sentiment/trend', params)
  },

  /* 点评分析报表页面 */
  // 点评表扬top以及出行目的、渠道分布
  getCommentQueryData(params) {
    return fecthPost('/cem/dataCube/query2', params)
  },
  getCommentQueryDataNew(params) {
    // return fecthPost('/cem/comment/analysis/pos/label/list', params)
    return fecthPost('/comment-label/pos/top', params, {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1/cem-4x`,
    })
  },
  getCommentQueryDataNewBad(params) {
    // return fecthPost('/cem/comment/analysis/neg/label/list', params)
    return fecthPost('/comment-label/neg/top', params, {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1/cem-4x`,
    })
  },
  getCommentAIAnalysis(params) {
    return fecthPost('/comment-label/ai/analysis/pos-neg', params, {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1/cem-4x`,
    })
  },
  getOursAndCompleteData(params) {
    return fecthPost('/cem/hotel/compete-analysis/competitor-label1/compare', params)
  },

  // 出行目的分布 新接口
  getPurposeList(params) {
    return fecthPost('/cem/comment/travel-purpose', params)
  },

  // 获取标签对应的营销策略
  getTagsRemark(params) {
    return fecthGet('/cem/label/remark', params)
  },
  // 渠道得分详情弹框
  fetchChannelScore(params) {
    return fecthPost('/cem/comment/commentDetailScoreAnalysis', params)
  },
  // 渠道得分详情弹窗- 用户点评分详情
  fetchUserCommentScore(params) {
    return fecthPost('/cem/comment/score/interval', params)
  },
  // 下载表格-渠道分趋势
  fetchExportTable(params) {
    return fecthPost('/cem/export/commentDetailScoreAnalysis/export', params)
  },

  // 下载表格-用户点评分详情
  fetchExportTableDetail(params) {
    return fecthPost('/cem/export/comment/score/Interval', params)
  },

  // 删除正在进行中的任务
  deleteTask(params) {
    return fecthPost('/cem/comment/score/task/cancel', params)
  },

  // 下载本酒店CSI 得分趋势
  getHotelCSIScoreTrend(params) {
    return fecthPost('/cem/vocust-score-task/score/trend/export', params)
  },
  // 本酒店加减分项分析
  getCSILabelAnalysis(params) {
    return fecthPost('/cem/hotel/csi/label/detail', params)
  },
  fetchOtherConfigToApollo(key) {
    const params = { key: key || 'data-config' }
    return fecthGet('/apollo/query-config', key)
  },
  // 日报-七日客诉对比
  getComplaintlevelTrend(params) {
    return fecthPost('/cem/living/complaintlevel-voice-statistics-trend', params)
  },

  // 华客分任务重算提示弹窗
  getTaskReCalculate(params) {
    return fecthGet('/cem/vocust-score-task/recalculate/alert', params)
  },

  // 华客分任务重算弹窗查看上报
  reportedTaskView(params) {
    return fecthPost('/cem/vocust-score-task/alert/view', params)
  },

  // 新的点评分预测

  // 历史列表
  historyTaskList(params) {
    return fecthPost('/cem/comment/score/task/list', params)
  },

  // 当前任务更新详情
  tripScoreGuess(params) {
    return fecthPost('/cem/comment/score/task/recalculate/list', params)
  },
  refreshTaskData(taskId) {
    return fecthGet(`/cem/comment/score/task/update?taskId=${taskId}`)
  },
  feedbackTask(params) {
    return fecthPost('/comment-score/submit/feedback', params, { baseURL: '/api/v1/cem-4x' })
  },
  //酒店变分历史列表
  scoreUpdateList(params) {
    return fecthPost('/cem/comment/score/change/list', params)
  },
  // 通知后端
  sendMessages(params) {
    return fecthPost('/cem/comment/score/task/alert/view', params)
  },
  // 获取CSI变化分析
  getCsiChangeAnalysis(params) {
    return fecthPost('/cem/vocust-score-task/analysis/csi-change', params)
  },

  // 竞争优势
  posTop(params) {
    return fecthPost('/competitive-analysis/label/pos/top', params, { baseURL: '/api/v1/cem-4x' })
  },
  negTop(params) {
    return fecthPost('/competitive-analysis/label/neg/top', params, { baseURL: '/api/v1/cem-4x' })
  },
  //taskid1-竞争优劣势

  getPosNegTaskId(params) {
    return fecthPost('/competitive-analysis/ai/analysis/label-pos-neg', params, { baseURL: '/api/v1/cem-4x' })
  },
  //关注度满意度taskid
  getCommentTypeList(params) {
    return fecthGet('/competitive-analysis/getFirstLevelDimension', params, { baseURL: '/api/v1/cem-4x' })
  },

  getSatisfactionTaskId(params) {
    return fecthPost('/competitive-analysis/ai/analysis/label-satisfaction', params, { baseURL: '/api/v1/cem-4x' })
  },
  getCompetitiveTaskId(params) {
    // 客源taskid
    return fecthPost('/competitive-analysis/ai/analysis/customer-source', params, { baseURL: '/api/v1/cem-4x' })
  },

  getSatisfiyData(params, cancelAxios) {
    const url = '/competitive-analysis/focus-satisfied'
    return fecthPost(url, params, {
      baseURL: '/api/v1/cem-4x',
      cancelToken: new axios.CancelToken(c => {
        cancelAxios[url] = c
      }),
    })
  },

  getTripPurpose(params) {
    return fecthPost('/competitive-analysis/user-travel-purpose/group', params, { baseURL: '/api/v1/cem-4x' })
  },

  relinkGetTaskId(params) {
    return fecthPost('/general/ai-analysis/retry', params, { baseURL: '/api/v1' })
  },

  getComepteData(params, cancelAxios) {
    const url = '/competitive-analysis/label/high-lights'
    return fecthPost(url, params, {
      baseURL: '/api/v1/cem-4x',
      cancelToken: new axios.CancelToken(c => {
        cancelAxios[url] = c
      }),
    })
  },

  getposnegsimp(params) {
    return fecthPost('competitive-analysis/ai/analysis/label-pos-neg/simp', params, { baseURL: '/api/v1/cem-4x' })
  },
  getcompetesimp(params) {
    return fecthPost('competitive-analysis/ai/analysis/high-lights/simp', params, { baseURL: '/api/v1/cem-4x' })
  },
  getcometeDetail(params) {
    return fecthPost('competitive-analysis/ai/analysis/high-lights/rival-hotel', params, { baseURL: '/api/v1/cem-4x' })
  },
  getHighLightAllDetail(params) {
    return fecthPost('competitive-analysis/ai/analysis/high-lights', params, { baseURL: '/api/v1/cem-4x' })
  },
  getHighLightSingalDetail(params) {
    return fecthPost('competitive-analysis/ai/analysis/high-lights/viewpoint', params, { baseURL: '/api/v1/cem-4x' })
  },

  // 标签相关的了

  getCloudInfo(params) {
    return fecthPost('competitive-analysis/channel-label/sift/feature-label/comment-customer-image', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },

  getTagInfo(params) {
    return fecthPost('competitive-analysis/channel-label/sift/feature-label/block', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },

  getTableInfo(params) {
    return fecthPost('competitive-analysis/channel-label/sift/feature-label/table', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },

  getRecommendInfo(params) {
    return fecthPost('competitive-analysis/channel-label/sift/feature-label/label-recommend', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },
  getLabelAnalysis(params) {
    return fecthPost('competitive-analysis/channel-label/base/rival/label-analysis', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },
  getLabelAnalysisDetail(params) {
    return fecthPost('competitive-analysis/channel-label/rival/comment-analysis', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },

  getFacilityTaskId(params) {
    return fecthPost('competitive-analysis/channel-label/ai/rival/comment-analysis/hotel-facility', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },
  getSummaryData(params) {
    return fecthPost('competitive-analysis/channel-label/ai/rival/comment-analysis/summary', params, {
      baseURL: '/api/v1/cem-4x',
    })
  },
  // 携程标签酒店白名单
  getApolloWhiteList() {
    return fecthGet(`/apollo/config?key=triplabel`)
  },
}
